import { render, staticRenderFns } from "./ColorsSection.vue?vue&type=template&id=7f61a63a&"
import script from "./ColorsSection.vue?vue&type=script&lang=js&"
export * from "./ColorsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports